import React from 'react';
import { NavLink } from 'react-router-dom'
import { Card, Pagination, message, Button } from 'antd';
import QueueAnim from 'rc-queue-anim';
import axios from '../../axios/index';
import moment from 'moment'
import './index.less'
export default class ListArt extends React.Component {
    state = {
        show: false,
        artList: [],
        totalCount: 0
    }
    params = {
        pageIndex: 1,
        pageCount: 4,
        filter: ''
    }
    str = '{"Rules": [], "Operate": "or", "Groups": [REPLACE]}'

    componentWillReceiveProps(nextProps) {
        this.setState({
            show: false,
            artList: []
        })
        if (nextProps.match !== undefined) {
            let d = nextProps.match.params.d;
            if (d !== null && d !== undefined && d !== 'undefined') {
                let opreate = 'equal';
                let data = d.split('=');
                const filed = data[0];
                let value = data[1];
                if(d.split('=')[0] === 'createTime'){
                    opreate = 'contains';
                    value = moment(d.split('=')[1]).format('YYYY/MM/DD')
                }
                this.params.filter = this.str.replace(/REPLACE/g, '{"Rules":[{"Field": "' + filed + '","Value": "' + value + '","Operate": "'+opreate+'"}],"Operate": "or", "Groups":[]}');
            }
        }
        this.showData();
    }

    showData() {
        let _this = this;
        axios.ajax({
            url: '/contents/list',
            data: {
                params: _this.params
            }
        }).then(res => {
            if (res.data === null || res.data === undefined) {
                message.error('服务器出现错误', 3);
                return;
            }
            if (res.totalCount === 0) {
                message.info('未查到数据', 3);
            }
            _this.state.artList = res.data
            let count = res.totalCount
            _this.state.totalCount = count

            let list = _this.renderListArt();
            _this.setState({
                artList: list
            })
            setTimeout(() => {
                _this.setState({
                    show: true
                })
            }, 500);
            
        }).catch(e => {
            if (e.code === -1) {
                message.error(e.message);
                return;
            }
        })
    }
    componentDidMount() {
        if (this.props.match !== undefined) {
            let d = this.props.match.params.d;
            if (d !== null && d !== undefined && d !== 'undefined') {
                let opreate = 'equal';
                let data = d.split('=');
                const filed = data[0];
                let value = data[1];
                if(d.split('=')[0] === 'createTime'){
                    opreate = 'contains';
                    value = moment(d.split('=')[1]).format('YYYY/MM/DD')
                }
                this.params.filter = this.str.replace(/REPLACE/g, '{"Rules":[{"Field": "' + filed + '","Value": "' + value + '","Operate": "'+opreate+'"}],"Operate": "or", "Groups":[]}');
            }
        }
        this.showData();
    }

    renderListArt = () => {
        return this.state.artList.map(item => {
            return (
                <Card bordered={false} hoverable={true} title={item.title} key={item.cid}
                    actions={
                        [<NavLink to={`/home/artical/${item.cid}`} style={{ color: 'rgb(120,120,120)' }} type='link' onClick={() => this.handleReadContent(item.cid)}>-- 阅读全文 --</NavLink>]
                    }>
                    <div className='text-over' style={{ "WebkitBoxOrient": "vertical" }}>{item.content}</div>
                </Card>
            )
        })
    }

    handleReadContent = (id) => {
        console.log(id)
    }

    onChange = (pageNumber) => {
        this.setState({
            show: false
        })
        this.params.pageIndex = pageNumber;
        this.showData();
    }

    render() {
        return (
            <div>
                <QueueAnim>
                    {
                        this.state.show ? [
                            this.state.artList.length > 0 ? this.state.artList : null
                        ] : null
                    }
                </QueueAnim>
                {
                    this.state.artList.length > 0 ? <Pagination showQuickJumper defaultCurrent={1} total={this.state.totalCount} pageSize={this.params.pageCount} onChange={this.onChange} /> : null
                }

            </div>
        );
    }
}